import { FinsightAvatar } from '@/Framework/UI/Organisms/ProfileWidget/Avatar';
import Menu from '@/Framework/UI/Organisms/ProfileWidget/Menu';
import { useSessionContext } from '@/users/application/Session/SessionContext';
import CheckUserAccess from 'src/finsight/ui/common/components/CheckUserAccess';
import { UserPlanType } from '@/users/domain/UserPlan';
import UserProfileFallback from '@/finsight/ui/common/components/header/Header/UserProfile/UserProfileFallback';
import { useUserPlanContext } from '@/finsight/application/User/UserPlan/UserPlanContext';
import SubscriptionsMenuItem from './SubscriptionsMenuItem';

import userProfileStyles from './userProfile.scss';

const UserProfileMenu = () => {
  const { currentUser, logout } = useSessionContext();
  const { checkAccessByUserPlan } = useUserPlanContext();

  const onLogout = (event) => {
    event.preventDefault();
    logout({ redirect: false });
  };

  return (
    <div className={ userProfileStyles.menuWrapper }>
      <Menu
        logoutAction={ onLogout }
        placement="bottom-end"
        ExtraComponent={ SubscriptionsMenuItem }
      >
        <CheckUserAccess
          checks={ [checkAccessByUserPlan(UserPlanType.STARTER)] }
          fallback={ (
            <UserProfileFallback />
          ) }
        >
          <FinsightAvatar
            email={ currentUser.email }
            firstName={ currentUser.firstName }
          />
        </CheckUserAccess>
      </Menu>
    </div>
  );
};

export default UserProfileMenu;
